import SingleProduct from "./SingleProduct"

interface IProps {
    message: string
}

const ProductMessage = ({message}: IProps) => {
    try {
        const product = JSON.parse(message)

        return <SingleProduct product={product} />
    } catch (e) {
        return
    }
}

export default ProductMessage
